/**
 * The case's members by user id, as a History row names who merged, undid or dismissed
 * (PRD-0075 slice 02). A user who has left the case, or a list not read yet, names nobody: the
 * row then reads "an analyst".
 */
import { useMemo } from 'react'
import { useCaseMembers } from '@/features/case-members/hooks/useCaseMembers'

export function useMemberNames(caseId: string): ReadonlyMap<string, string> {
  const { members } = useCaseMembers(caseId)
  return useMemo(
    () => new Map(members.map(member => [member.user_id, member.full_name || member.username])),
    [members]
  )
}
